import { useState } from "react"
import { cn } from "~/utils/misc.tsx"

export const Ripple = ({className}: {className?: string}) => {
  const [state, setState] = useState({ spanStyles: {}, count: 0 })
  let bounce: any
  const callCleanUp = (cleanup: any, delay: any) => {
    return function() {
      clearTimeout(bounce);
      bounce = setTimeout(() => {
        cleanup();
      }, delay);
    }
  }

  const showRipple = (e: any) => {
    const rippleContainer = e.currentTarget;
    const size = rippleContainer.offsetWidth;
    const pos = rippleContainer.getBoundingClientRect();
    const x = e.pageX - pos.x - (size / 2);
    const y = e.pageY - pos.y - (size / 2);

    const spanStyles = { top: y + 'px', left: x + 'px', height: size + 'px', width: size + 'px' };
    const count = state.count + 1;
    setState({
      spanStyles: { ...state.spanStyles, [count]: spanStyles },
      count: count
    });
  }

  const cleanUp = () => {
    setState({ spanStyles: {}, count: 0 });
  }

  const renderRippleSpan = () => {
    const spanStyles: any = state.spanStyles
    const spanArray = Object.keys(spanStyles);
    if (spanArray && spanArray.length > 0) {
      return (
        spanArray.map((key, index) => {
          return <RippleSpan key={'spanCount_' + index} style={{ ...spanStyles[key] }} className={className}/>
        })
      )
    } else {
      return null;
    }
  }
  return (
    <div className="absolute inset-0"
      onMouseDown={showRipple}
      onMouseUp={callCleanUp(cleanUp, 10000)}
    >
      {renderRippleSpan()}
    </div>
  )
}

const RippleSpan = (props: any) => {
  return (
    <span
      {...props}
      className={cn("scale-0 rounded-full absolute opacity-75 bg-white animate-ripple-enter", props.className)}
    />
  )
}
